import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Shield } from 'lucide-react';

export const CGUPage = () => {
  return (
    <div className="min-h-screen bg-dark pt-20 md:pt-24 pb-20 md:pb-12">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Back button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-gold transition-colors mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>
        
        <div className="glass-card p-6 md:p-10">
          {/* Header */}
          <div className="text-center mb-10">
            <Shield className="w-12 h-12 text-gold mx-auto mb-4" />
            <h1 className="font-serif text-2xl md:text-3xl gold-gradient-text mb-2">
              Conditions Générales d'Utilisation
            </h1>
            <p className="text-gray-500 text-sm">www.discreetlux.com</p>
            <p className="text-gray-500 text-sm mt-1">Édité par ABC Interactive</p>
          </div>
          
          {/* Content */}
          <div className="space-y-8 text-gray-300">
            {/* Article 1 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">1. PRÉSENTATION DU SITE</h2>
              <p className="mb-3 leading-relaxed">
                Le site internet accessible à l'adresse www.discreetlux.com (ci-après le « Site ») est édité par la société :
              </p>
              <div className="bg-dark-subtle p-4 rounded-lg text-sm">
                <p><strong className="text-white">ABC Interactive</strong></p>
                <p>Société : en cours</p>
                <p>Immatriculée au RCS de Paris sous le numéro en cours</p>
                <p>Dont le siège social est situé en cours</p>
              </div>
              <p className="mt-3 leading-relaxed">
                Le Site constitue une plateforme communautaire en ligne destinée exclusivement aux personnes majeures, permettant la mise en relation d'adultes dans le cadre de rencontres libertines et consenties.
              </p>
            </section>
            
            {/* Article 2 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">2. DÉFINITIONS</h2>
              <ul className="list-disc list-inside space-y-2 text-sm">
                <li><strong className="text-white">Utilisateur</strong> : toute personne physique majeure inscrite sur le Site</li>
                <li><strong className="text-white">Compte</strong> : espace personnel créé par l'Utilisateur</li>
                <li><strong className="text-white">Services</strong> : ensemble des fonctionnalités proposées gratuitement ou via abonnement</li>
                <li><strong className="text-white">Contenus</strong> : textes, photographies, vidéos, messages publiés par les Utilisateurs</li>
                <li><strong className="text-white">Abonnement</strong> : formule payante permettant l'accès à certaines fonctionnalités</li>
              </ul>
            </section>
            
            {/* Article 3 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">3. CONDITIONS D'ACCÈS</h2>
              <p className="mb-3 leading-relaxed">L'accès au Site est strictement réservé :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>aux personnes âgées de 18 ans minimum</li>
                <li>juridiquement capables de contracter</li>
                <li>utilisant le Site à titre exclusivement personnel</li>
              </ul>
              <p className="mb-3 leading-relaxed text-red-400">
                Toute utilisation à des fins de prostitution, racolage, escorting ou activité commerciale est strictement interdite.
              </p>
              <p className="leading-relaxed text-sm">
                ABC Interactive se réserve le droit de mettre en place toute procédure de vérification d'âge jugée nécessaire conformément à la réglementation applicable (ARCOM, RGPD).
              </p>
            </section>
            
            {/* Article 4 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">4. INSCRIPTION</h2>
              <p className="mb-3 leading-relaxed">L'inscription implique :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>la création d'un Compte personnel</li>
                <li>la fourniture d'informations exactes et sincères</li>
                <li>l'acceptation sans réserve des présentes CGU</li>
              </ul>
              <p className="leading-relaxed text-sm">
                L'Utilisateur est seul responsable de la confidentialité de ses identifiants. Toute action réalisée via son Compte est réputée effectuée par lui.
              </p>
            </section>
            
            {/* Article 5 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">5. SERVICES PROPOSÉS</h2>
              <p className="mb-3 leading-relaxed">Le Site permet notamment :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>la création d'un profil</li>
                <li>la publication de contenus</li>
                <li>l'échange de messages privés</li>
                <li>la participation à des événements</li>
                <li>l'accès à des fonctionnalités premium via Abonnement</li>
              </ul>
              <p className="leading-relaxed text-sm">
                Certaines fonctionnalités peuvent être accessibles uniquement après souscription à un Abonnement payant.
              </p>
            </section>
            
            {/* Article 6 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">6. ABONNEMENTS</h2>
              <p className="mb-3 leading-relaxed">Les abonnements :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>sont souscrits pour une durée déterminée</li>
                <li>sont renouvelés automatiquement sauf résiliation</li>
                <li>peuvent être résiliés à tout moment depuis le Compte utilisateur</li>
              </ul>
              <p className="leading-relaxed text-sm text-amber-400">
                La suppression du Compte n'entraîne pas automatiquement la résiliation de l'Abonnement.
              </p>
            </section>
            
            {/* Article 7 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">7. DROIT DE RÉTRACTATION</h2>
              <p className="mb-3 leading-relaxed">
                Conformément à l'article L221-28 du Code de la consommation :
              </p>
              <p className="leading-relaxed text-sm bg-dark-subtle p-4 rounded-lg">
                L'Utilisateur reconnaît que l'exécution du service commence immédiatement après validation de son Abonnement et renonce expressément à son droit de rétractation.
              </p>
            </section>
            
            {/* Article 8 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">8. OBLIGATIONS DES UTILISATEURS</h2>
              <p className="mb-3 leading-relaxed">L'Utilisateur s'engage notamment à ne pas :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>publier de contenus illégaux, diffamatoires, injurieux ou violents</li>
                <li>porter atteinte à la vie privée d'autrui</li>
                <li>utiliser le Site à des fins commerciales</li>
                <li>créer de faux profils</li>
                <li>diffuser des virus ou logiciels malveillants</li>
                <li>collecter des données personnelles d'autres Utilisateurs</li>
                <li>proposer des services tarifés à caractère sexuel</li>
              </ul>
              <p className="leading-relaxed text-sm mb-2">Tout manquement pourra entraîner :</p>
              <ul className="list-disc list-inside space-y-1 text-sm text-red-400">
                <li>suspension du Compte</li>
                <li>suppression des Contenus</li>
                <li>résiliation définitive sans remboursement</li>
              </ul>
            </section>
            
            {/* Article 9 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">9. PROTECTION DES MINEURS</h2>
              <p className="mb-3 leading-relaxed text-red-400 font-semibold">
                L'accès au Site est strictement interdit aux mineurs.
              </p>
              <p className="leading-relaxed text-sm">
                Toute tentative d'exploitation sexuelle impliquant un mineur entraînera :
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm mt-2 text-red-400">
                <li>la suppression immédiate du Compte</li>
                <li>le signalement aux autorités compétentes</li>
              </ul>
            </section>
            
            {/* Article 10 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">10. RESPONSABILITÉ</h2>
              <p className="mb-3 leading-relaxed">
                ABC Interactive agit en qualité d'hébergeur de contenus au sens de la loi n°2004-575 du 21 juin 2004.
              </p>
              <p className="mb-2 leading-relaxed text-sm">ABC Interactive ne peut être tenue responsable :</p>
              <ul className="list-disc list-inside space-y-1 text-sm">
                <li>des informations publiées par les Utilisateurs</li>
                <li>de la véracité des profils</li>
                <li>des rencontres physiques organisées entre Utilisateurs</li>
                <li>de toute atteinte à la vie privée résultant des contenus diffusés volontairement</li>
              </ul>
            </section>
            
            {/* Article 11 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">11. DONNÉES PERSONNELLES</h2>
              <p className="mb-3 leading-relaxed">Les données personnelles sont traitées conformément au :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>Règlement (UE) 2016/679 (RGPD)</li>
                <li>Loi Informatique et Libertés</li>
              </ul>
              <p className="mb-2 leading-relaxed text-sm">L'Utilisateur dispose des droits suivants :</p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm mb-3">
                <span className="bg-dark-subtle px-3 py-1 rounded">accès</span>
                <span className="bg-dark-subtle px-3 py-1 rounded">rectification</span>
                <span className="bg-dark-subtle px-3 py-1 rounded">suppression</span>
                <span className="bg-dark-subtle px-3 py-1 rounded">limitation</span>
                <span className="bg-dark-subtle px-3 py-1 rounded">portabilité</span>
                <span className="bg-dark-subtle px-3 py-1 rounded">opposition</span>
              </div>
              <p className="leading-relaxed text-sm">
                Toute demande peut être adressée à :
              </p>
              <a href="mailto:contact@discreetlux.com" className="inline-flex items-center gap-2 text-gold hover:underline mt-2">
                <Mail className="w-4 h-4" />
                contact@discreetlux.com
              </a>
            </section>
            
            {/* Article 12 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">12. PROPRIÉTÉ INTELLECTUELLE</h2>
              <p className="leading-relaxed">
                Le Site et l'ensemble de ses éléments sont la propriété exclusive de ABC Interactive. Toute reproduction totale ou partielle est strictement interdite sans autorisation préalable.
              </p>
            </section>
            
            {/* Article 13 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">13. RÉSILIATION</h2>
              <p className="mb-3 leading-relaxed">ABC Interactive peut suspendre ou supprimer tout Compte :</p>
              <ul className="list-disc list-inside space-y-1 text-sm mb-3">
                <li>en cas de non-respect des présentes CGU</li>
                <li>en cas de comportement frauduleux</li>
                <li>en cas de contenu illicite</li>
              </ul>
              <p className="leading-relaxed text-sm text-amber-400">
                Aucun remboursement ne pourra être exigé.
              </p>
            </section>
            
            {/* Article 14 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">14. MODIFICATION DES CGU</h2>
              <p className="leading-relaxed">
                Les présentes CGU peuvent être modifiées à tout moment. Les Utilisateurs seront informés via le Site ou par email.
              </p>
            </section>
            
            {/* Article 15 */}
            <section>
              <h2 className="text-lg font-semibold text-gold mb-3">15. DROIT APPLICABLE</h2>
              <p className="leading-relaxed">
                Les présentes CGU sont soumises au droit français. Tout litige relève de la compétence exclusive des tribunaux du ressort du siège social de ABC Interactive.
              </p>
            </section>
          </div>
          
          {/* Footer */}
          <div className="mt-10 pt-6 border-t border-white/10 text-center">
            <p className="text-gray-500 text-sm">
              Version du 10 mars 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGUPage;
